import React, { useState } from 'react';

// state: querystring for now
// todo: object as state? potential performance issue
const UserContext = React.createContext([{}, () => {}]);

const UserProvider = (props) => {
  const [state, setState] = useState({});
  return <UserContext.Provider value={[state, setState]}>{props.children}</UserContext.Provider>;
};

const UserConsumer = UserContext.Consumer;

export { UserProvider, UserContext, UserConsumer };
